import { FC, memo, useMemo } from "react";
import { Table, TableColumn } from "@vilocnv/allsetra-core";
import { STATIONARY_INNER_TABLE_COLUMNS } from "app/data/constants";
import { useTranslation } from "react-i18next";

const customStyles = {
  cells: {
    style: {
      justifyContent: "flex-start"
    }
  }
};

interface StationaryFinalDataProps {
  data: any;
}

const StationaryFinalData: FC<StationaryFinalDataProps> = ({ data }) => {
  const { t } = useTranslation(["translation", "tableHeadingsTranslation"]);

  const tableColumns: TableColumn<any>[] = useMemo(
    () => STATIONARY_INNER_TABLE_COLUMNS(t),
    [t]
  );

  return (
    <Table
      columns={tableColumns}
      data={data.data}
      noTableHead={true}
      pagination={false}
      customStyles={customStyles}
      translator={t}
    />
  );
};

export default memo(StationaryFinalData);
